import { userRoles } from "./constants";

export const isUserSeller = (user) => (user === null ? false : user.roleId === userRoles.seller);

export const isUserDriver = (user) => (user === null ? false : user?.roleId === userRoles.driver);

export const getUserRoleIds = (user) => {
  if (!user) return [];
  if (Array.isArray(user.userRole) && user.userRole.length) {
    return user.userRole.map((role) => role.roleId);
  }
  return user.roleId != null ? [user.roleId] : [];
};

export const hasRole = (user, roleId) => getUserRoleIds(user).includes(roleId);

export const canSwitchRole = (user) =>
  hasRole(user, userRoles.admin) && hasRole(user, userRoles.driver);

export const switchActiveRole = (targetRoleId) => {
  const user = JSON.parse(localStorage.getItem("user")) ?? {};
  const updatedUser = { ...user, roleId: targetRoleId };
  localStorage.setItem("user", JSON.stringify(updatedUser));
  return updatedUser;
};
